export default __webpack_public_path__ + "static/img3_question_settings-0dcf213e6af02d51be2a728bd7a9e6b6.png";